import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import LinkBuildingInteligente from "@/pages/servicios/LinkBuildingInteligente";


export const Route = createFileRoute("/servicios/link-building-inteligente")({
  head: () => ({
    meta: [
      { title: "Link Building con IA | Autoridad Web Real | SEOEVOLUTION" },
      { name: "description", content: "Construimos autoridad web real con enlaces de sitios relevantes en tu sector. Estrategia white hat 100% con IA. Solo trabajamos con 1 cliente por sector y zona." },
      { name: "keywords", content: "link building, construcción de enlaces, backlinks, SEO off page, autoridad web" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/link-building-inteligente" },
      { property: "og:title", content: "Link Building con IA | Autoridad Web Real | SEOEVOLUTION" },
      { property: "og:description", content: "Construimos autoridad web real con enlaces de sitios relevantes en tu sector. Estrategia white hat 100% con IA." },
      { name: "twitter:title", content: "Link Building con IA | Autoridad Web Real | SEOEVOLUTION" },
      { name: "twitter:description", content: "Construimos autoridad web real con enlaces de sitios relevantes en tu sector. Estrategia white hat 100% con IA." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/link-building-inteligente" }],
    scripts: serviceSchemaScripts("link-building-inteligente"),
  }),
  component: LinkBuildingInteligente,
});
